import { render, staticRenderFns } from "./SceneBuilder.vue?vue&type=template&id=1c67f32e&"
import script from "./SceneBuilder.vue?vue&type=script&lang=js&"
export * from "./SceneBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports